const createRequestInterceptor = httpClient => {
  let { client } = httpClient

  client.interceptors.request.use(
    config => {
      config.headers = {
        'Accept-Language': localStorage.getItem('locale'),
        Authorization: sessionStorage.getItem('mavAuth')
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
}

const createRequestInterceptorBillma = httpClient => {
  let { client } = httpClient

  client.interceptors.request.use(
    config => {
      let token = sessionStorage.getItem('mavAuth')
      if (token) {
        token = token.replace('Token', 'Bearer')
      }
      config.headers = {
        'Accept-Language': localStorage.getItem('locale'),
        Authorization: token
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )
}

const createResponseInterceptor = httpClient => {
  let { client } = httpClient
  client.interceptors.response.use(
    request => {
      return request
    },
    error => {
      return Promise.reject(error)
    }
  )
}

export default {
  createRequestInterceptor,
  createResponseInterceptor,
  createRequestInterceptorBillma
}
